import { render } from "./p-card.vue?vue&type=template&id=64d83ddd&scoped=true"
import script from "./p-card.vue?vue&type=script&lang=js"
export * from "./p-card.vue?vue&type=script&lang=js"

import "./p-card.vue?vue&type=style&index=0&id=64d83ddd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d83ddd"],['__file',"src/components/p-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64d83ddd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64d83ddd', __exports__)) {
    api.reload('64d83ddd', __exports__)
  }
  
  module.hot.accept("./p-card.vue?vue&type=template&id=64d83ddd&scoped=true", () => {
    api.rerender('64d83ddd', render)
  })

}


export default __exports__